const COMPONENT_NAME = "Link";
const INVALID_PROP_ERROR = `${COMPONENT_NAME}-error: Missing children prop`;
const LANG_PARAM = "langId";
const REFINE_PARAM = "refine";
export {
  COMPONENT_NAME,
  INVALID_PROP_ERROR,
  LANG_PARAM,
  REFINE_PARAM
};
